export default function CtaBand() {
  return (
    <section className="relative px-4 md:px-8 py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm-toned%20geometric%20background%20with%20layered%20folded%20paper%20shapes%20and%20a%20soft%20spotlight%20glow%2C%20deep%20crimson%20and%20amber%20gradient%20accents%20on%20a%20muted%20dark%20umber%20base%2C%20minimal%20editorial%20texture%20with%20subtle%20grain%2C%20wide%20banner%20composition%20with%20large%20calm%20empty%20areas%20for%20overlaid%20text%2C%20dramatic%20contrast%2C%20no%20text%2C%20no%20recognizable%20objects&width=1600&height=700&seq=heiliao-cta-band&orientation=landscape"
          alt="黑料社区匿名投稿入口背景"
          title="黑料社区匿名投稿 曝光台线索提交"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/55"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 text-background-100 text-xs md:text-sm">
          <i className="ri-lock-2-line text-base"></i>
          <span>投稿通道全天开放</span>
        </span>
        <h3 className="mt-5 font-heading text-2xl md:text-4xl font-bold leading-tight text-background-50">
          有线索？现在就交给黑料社区
        </h3>
        <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200 max-w-2xl mx-auto">
          私信投稿也好，曝光台提交也好，都不用暴露身份。投稿后由社区审核展示，让每一条线索都有机会被看见。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="#submit"
            className="flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-fill"></i>
            <span>前往匿名投稿</span>
          </a>
          <a
            href="#privacy"
            className="flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/30 text-background-100 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shield-check-line"></i>
            <span>查看隐私保护</span>
          </a>
        </div>
      </div>
    </section>
  );
}